import { render } from "./CouponRecive.vue?vue&type=template&id=6ddf4812&scoped=true"
import script from "./CouponRecive.vue?vue&type=script&lang=js"
export * from "./CouponRecive.vue?vue&type=script&lang=js"

import "./CouponRecive.vue?vue&type=style&index=0&id=6ddf4812&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-case/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddf4812"]])

export default __exports__